import CustomViewAttributesStore, { CustomViewAttributesStoreContext } from "csi/middleware/customView/attributes/CustomViewAttributesStore";
import { SaveDialogProps } from "designSystem/components/dialog/SaveDialog";
import { Box, SaveDialog } from "designSystem/index";
import React, { FunctionComponent } from "react";
import AttributesEditor from "./AttributesEditor";

export interface AttributesDialogProps extends SaveDialogProps {
    store: CustomViewAttributesStore;
}

const AttributesDialog: FunctionComponent<AttributesDialogProps> = (props) => {
	const { store, ...otherProps } = props;
	
	return (
		<SaveDialog
			contentDisplayFlex
			contentSpacing={0}
			fullHeight
			minWidth={640}
			open
			scrollContent="none"
			showClose
			{...otherProps}
		>
			{{
				main: (
					<CustomViewAttributesStoreContext.Provider value={store}>
						<Box growNoOverflow>
							<AttributesEditor />
						</Box>
					</CustomViewAttributesStoreContext.Provider>
				),
			}}
		</SaveDialog>
	);
};

export default AttributesDialog;